import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useUIStore } from '@/lib/store/uiStore';
import ChatArea from '@/components/chat/ChatArea';
import ChatInput from '@/components/chat/ChatInput';

function ChatPage() {
  const { conversationId } = useParams<{ conversationId?: string }>();
  const { setCurrentConversationId } = useUIStore();

  useEffect(() => {
    setCurrentConversationId(conversationId || null);
  }, [conversationId, setCurrentConversationId]);

  return (
    <div className="h-full flex flex-col bg-background">
      <div className="flex-1 overflow-hidden">
        <ChatArea conversationId={conversationId || null} />
      </div>
      <ChatInput conversationId={conversationId || null} />
    </div>
  );
}

export default ChatPage;
